import { useModal } from '@billy/design-system'
import { useEffect, useRef } from 'react'

import { ModalId } from '../../enums/modalId'
import { EmberEventFn } from '../../types/emberEventFn'

export function useModalCloseWatcher(modalId: ModalId, onClose: EmberEventFn): void {
  const { isOpen } = useModal(modalId)
  const wasOpen = useRef(false)

  useEffect(() => {
    if (wasOpen.current && !isOpen) {
      onClose({ detail: null })
    }
    wasOpen.current = isOpen
  }, [isOpen, onClose])
}
